import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  setOnBoardingValue,
  setOnBoardingValues,
} from "domain/on-boarding/on-boarding.actions";
import { OnBoardingState } from "domain/on-boarding/on-boarding.slice";

export function updateOnBoardingValue(
  userId: number,
  type: keyof OnBoardingState,
  dispatch: ThunkDispatch<any, any, any>
) {
  const onBoardingValues = JSON.parse(
    localStorage.getItem(`innizio-on-boarding-${userId}`) || " {}"
  );
  localStorage.setItem(
    `innizio-on-boarding-${userId}`,
    JSON.stringify({ ...onBoardingValues, [type]: true })
  );
  dispatch(setOnBoardingValue({ type, value: true }));
}

export function getSessionOnBoardingValues(
  userId: number,
  dispatch: ThunkDispatch<any, any, any>
) {
  const onBoarding = JSON.parse(
    localStorage.getItem(`innizio-on-boarding-${userId}`) || " {}"
  );
  dispatch(setOnBoardingValues(onBoarding));
}
